module.exports = __webpack_public_path__ + "img/flomskredaktsomhet.2491a693.jpg";